// extracted by css-extract-rspack-plugin
export default {"content":"content-Kr2dYh","underlined":"underlined-ZuqgGt"};